/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GeneratorStatusRepresentation
 */
export interface GeneratorStatusRepresentation {
    /**
     * Unique uuid key of the status
     * @type {string}
     * @memberof GeneratorStatusRepresentation
     */
    key: string;
    /**
     * Unique key of the data provider for this status
     * @type {string}
     * @memberof GeneratorStatusRepresentation
     */
    dataProviderKey: string;
    /**
     * Unique uuid key mapping to an i18n entry
     * @type {string}
     * @memberof GeneratorStatusRepresentation
     */
    name: string;
    /**
     * Hex color code for this status
     * @type {string}
     * @memberof GeneratorStatusRepresentation
     */
    color: string;
}

/**
 * Check if a given object implements the GeneratorStatusRepresentation interface.
 */
export function instanceOfGeneratorStatusRepresentation(value: object): value is GeneratorStatusRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('dataProviderKey' in value) || value['dataProviderKey'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('color' in value) || value['color'] === undefined) return false;
    return true;
}

export function GeneratorStatusRepresentationFromJSON(json: any): GeneratorStatusRepresentation {
    return GeneratorStatusRepresentationFromJSONTyped(json, false);
}

export function GeneratorStatusRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeneratorStatusRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'dataProviderKey': json['dataProviderKey'],
        'name': json['name'],
        'color': json['color'],
    };
}

export function GeneratorStatusRepresentationToJSON(json: any): GeneratorStatusRepresentation {
    return GeneratorStatusRepresentationToJSONTyped(json, false);
}

export function GeneratorStatusRepresentationToJSONTyped(value?: GeneratorStatusRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'dataProviderKey': value['dataProviderKey'],
        'name': value['name'],
        'color': value['color'],
    };
}

